const products = [
  {
    title: 'Water Tanks',
    image: '/assets/500Lit.png',
    description: 'Premium PUF insulated water storage tanks in multiple capacities.'
  },
  {
    title: 'Milk Cans',
    image: '/assets/40Lit.png',
    description: 'Food-grade stainless steel milk cans for dairy industry.'
  },
  {
    title: 'Custom Solutions',
    image: '/assets/500Lit.png',
    description: 'Customizable water and liquid storage solutions for special needs.'
  },
  {
    title: 'Industrial Storage',
    image: '/assets/40Lit.png',
    description: 'Heavy-duty storage solutions for industrial and commercial applications.'
  }
];

export default function ProductsPreview() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="mb-8 sm:mb-12 text-center">
          <span className="text-amber-600 font-semibold text-xs sm:text-sm tracking-widest uppercase">Our Products</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-amber-900 mt-2 mb-3">Featured Product Categories</h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">Discover our premium range of products engineered with precision for superior performance.</p>
        </div>
        <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((product) => (
            <div
              key={product.title}
              className="group relative bg-white rounded-2xl border-2 border-amber-100 overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 hover:border-amber-400 cursor-pointer"
            >
              {/* Image Container */}
              <div className="relative h-48 sm:h-56 md:h-64 bg-gradient-to-br from-amber-50 to-amber-100 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-contain object-center p-4 sm:p-6 group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/assets/500Lit.png'; }}
                />
                {/* Overlay effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Content Container */}
              <div className="p-4 sm:p-6 relative z-10">
                <h3 className="text-lg sm:text-xl font-bold text-amber-900 mb-2 group-hover:text-amber-700 transition-colors">{product.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed line-clamp-2">
                  {product.description}
                </p>

                {/* Bottom accent */}
                <div className="mt-4 pt-4 border-t-2 border-amber-100 group-hover:border-amber-400 transition-colors duration-300">
                  <p className="text-xs font-semibold text-amber-600 uppercase tracking-widest">Learn More →</p>
                </div>
              </div>

              {/* Premium badge */}
              <div className="absolute top-3 right-3 bg-amber-600 text-white px-2 py-1 rounded-lg text-xs font-bold uppercase tracking-wide shadow-md group-hover:bg-amber-700 transition-colors">
                Premium
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
